import { getFullDomainValue } from 'utils/general'
import { REGEX_DOMAIN, REGEX_ERROR_PATH, REGEX_PASSWORD } from '../../constants'

import { ACTION_CREATE, GATED_MODE_EMAIL_GATE, GATED_MODE_PASSWORD } from './interface'

export const validate = (action, { domainValues, uploadValues, toggleValues }) => {
  const errors = {}

  for (let domainKey in domainValues) {
    if (domainKey === 'subdomain' && domainValues[domainKey]) {
      if (!REGEX_DOMAIN.test(domainValues[domainKey]?.toLowerCase())) {
        errors.domainValues = { ...errors.domainValues, subdomain: 'Please enter a valid website name.' }
      }
    }
  }

  for (let uploadKey in uploadValues) {
    if (action === ACTION_CREATE) {
      if (uploadKey === 'selectedFile' && !uploadValues[uploadKey]) {
        errors.uploadValues = { ...errors.uploadValues, selectedFile: 'Please select a file' }
      }
    }
  }

  for (let toggleKey in toggleValues) {
    if (toggleKey === 'password' && toggleValues['passwordProtected']) {
      if (!REGEX_PASSWORD.test(toggleValues[toggleKey]?.toLowerCase())) {
        errors.toggleValues = { ...errors.toggleValues, password: 'Please enter a valid password' }
      }
    }

    if (toggleKey === 'errorPath' && toggleValues['siteConfiguration']) {
      if (!REGEX_ERROR_PATH.test(toggleValues[toggleKey]?.toLowerCase())) {
        errors.toggleValues = {
          ...errors.toggleValues,
          errorPath: 'Please enter a valid error path. Path should always begin with /. Eg: /index.html'
        }
      }
    }
  }

  return errors
}

export const updateSiteRequest = ({ domainValuesToUpdate, toggleValuesToUpdate }) => {
  let newDomain = getFullDomainValue(domainValuesToUpdate?.subdomain, domainValuesToUpdate?.domainSuffix) || null
  let siteSettings = toggleValuesToUpdate

  if (siteSettings?.disableIndexing) {
    siteSettings.disableIndexing = siteSettings.disableIndexing.toString()
  }

  if (siteSettings?.siteConfiguration || siteSettings?.errorPath) {
    siteSettings.siteConfiguration = JSON.stringify({ errorPath: siteSettings.errorPath })
    delete siteSettings.errorPath
  }

  if (siteSettings?.gatedMode) {
    switch (siteSettings.gatedMode) {
      case GATED_MODE_EMAIL_GATE:
        siteSettings.enableEmailGate = true
        siteSettings.passwordProtected = false
        break
      case GATED_MODE_PASSWORD:
        siteSettings.enableEmailGate = false
        siteSettings.passwordProtected = true
        break
      default:
        siteSettings.enableEmailGate = false
        siteSettings.passwordProtected = false
    }
    delete siteSettings?.gatedMode
  }

  return {
    newDomain,
    siteSettings
  }
}
